<template>
  <div>
    <v-textarea
      ref="textarea"
      v-model="computedValue"
      :hide-details="hideDetails && (!rules || !rules.length)"
      :label="label"
      :rows="rows"
      :rules="rules"
      clear-icon="mdi-close-circle-outline"
      clearable
      dense
      outlined
    >
      <template v-if="$vuetify.breakpoint.smAndUp" v-slot:append>
        <div class="d-flex flex-column fill-height justify-space-between gap-2">
          <v-btn
            class="px-0"
            min-width="36"
            small
            style="font-size: 1.5em"
            text
            :title="$t('suggestinput.emoji')"
            @click="emojiModel = true"
          >
            <div>🙂</div>
          </v-btn>
          <v-btn
            v-if="label === $t('suggestinput.aboutUs') || label==='متن خاطره'"
            class="px-0"
            :loading="loading_Ai"
            min-width="36"
            color="blue lighten-2"
            small
            style="font-size: 1.5em"
            text
            :title="$t('suggestinput.generateText')"
            @click="label==='متن خاطره'? generateTextForMemory(prompt): genetateTextForAboutus(prompt)"
          >
            <v-icon>mdi mdi-creation-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </v-textarea>

    <v-btn
      v-if="$vuetify.breakpoint.xs"
      class="px-2"
      style="font-size: 1.5em"
      text
      :title="$t('suggestinput.emoji')"
      @click="emojiModel = true"
    >
      <div>🙂</div>
    </v-btn>
    <TogetherAiUpgradeNew
      v-model="showUpgrade"
      :current-package.sync="currentPackage"
      class="contentinfo"
    />
    <custom-popup
      v-model="emojiModel"
      :cons="cons"
      hide-confirm
      max-width="500"
    >
      <emoji-selector :inputBox="$refs.textarea" />
    </custom-popup>
  </div>
</template>

<script>
import EmojiSelector from "./emoji";
import TogetherAiUpgradeNew from "@/view/components/adapters/AIGeneration/togetherAiUpgradeNew.vue";

export default {
  name: "suggestText",

  components: { EmojiSelector, TogetherAiUpgradeNew },

  props: {
    rules: Array,
    value: String,
    label: String,
    prompt: String,
    hideDetails: {
      type: Boolean,
      default: true,
    },
    rows: {
      type: [String, Number],
      default: 5,
    },
  },

  data() {
    return {
      showUpgrade: false,
      currentPackage: {},
      loading_Ai: false,
      AiModel: false,
      emojiModel: false,
    };
  },

  methods: {
        generateTextForMemory(prompt) {
      this.loading_Ai = true;
      let needPack = !this.computedCurrentPackage.count;
      
      const textMessage = {
        fa: `شما یک نویسنده خلاق و داستان‌سرای احساسی هستید. یک متن زیبا، احساسی و نوستالژیک (حداقل ۲۰۰ کلمه) برای یک «قاب خاطره» بنویسید که موضوع اصلی آن "${prompt}" است. این قاب خاطره دارای یک کیوآر کد (QR Code) است که با اسکن آن، خاطرات دیجیتال (عکس، فیلم یا صدا) زنده می‌شوند. متن باید حس دلتنگی شیرین، عشق، گرما و اهمیت ثبت لحظات ماندگار را به مخاطب منتقل کند. لحن باید صمیمی، شاعرانه و عمیقاً تاثیرگذار باشد. موضوع "${prompt}" را به شکلی طبیعی و به عنوان یک یادگاری ارزشمند در متن ادغام کنید. تأکید کنید که این قاب، پلی است بین دنیای فیزیکی و خاطرات دیجیتال. فقط و فقط متن نهایی را به زبان فارسی تولید کنید و از نوشتن هرگونه توضیح اضافه، مقدمه یا نتیجه‌گیری غیرمرتبط خودداری کنید.`,
        
        en: `You are a creative writer and an expert emotional storyteller. Write a beautiful, nostalgic, and deeply emotional text (at least 200 words) for a 'Memory Frame' focusing on the theme: "${prompt}". This Memory Frame includes a QR code that, when scanned, brings digital memories (photos, videos, or audio) to life. The text should convey a sweet sense of nostalgia, warmth, love, and the importance of preserving timeless moments. The tone must be intimate, poetic, and highly impactful. Weave the theme "${prompt}" naturally into the narrative as a cherished keepsake, emphasizing that this frame is a bridge between the physical world and digital memories. Generate ONLY the final English text, without any conversational filler, introductions, or additional explanations.`,
        
        ar: `أنت كاتب مبدع وراوي قصص عاطفية خبير. اكتب نصًا جميلًا وحنينيًا وعاطفيًا بعمق (لا يقل عن 200 كلمة) لـ "إطار ذكريات" يركز على موضوع: "${prompt}". يحتوي إطار الذكريات هذا على رمز QR، عند مسحه ضوئيًا، يعيد إحياء الذكريات الرقمية (الصور أو مقاطع الفيديو أو الصوت). يجب أن ينقل النص شعورًا حلوًا بالحنين والدفء والحب وأهمية الحفاظ على اللحظات الخالدة. يجب أن تكون النبرة حميمية وشاعرية ومؤثرة للغاية. ادمج موضوع "${prompt}" بشكل طبيعي في السرد كتذكار عزيز، مع التأكيد على أن هذا الإطار يمثل جسرًا بين العالم المادي والذكريات الرقمية. قم بتوليد النص النهائي باللغة العربية فقط، دون أي حشو أو مقدمات أو شروحات إضافية.`
      }[this.$i18n.locale];

      this.$api
        .post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: textMessage,
        })
        .then(({ data }) => {
          this.computedValue = data.choices[0].message.content;
          this.currentPackage = data.package;

          if (needPack && !data.package.remaining) {
            this.showUpgrade = true;
            this.$modal.error(
              this.$t("suggestinput.error"),
              this.$t("suggestinput.errorMessage") 
            );
          }
        })
        .catch((err) => {
          let message = this.$t("suggestinput.errorMessage_400");
          if (err.response && err.response.status === 403) {
            this.$toast.error(this.$t("suggestinput.errorMessage_403"));
            this.showUpgrade = true;
          } else {
            this.$modal.error(this.$t("suggestinput.error"), message);
          }
          this.loading_Ai = false;
        })
        .finally(() => {
          this.loading_Ai = false;
        });
    },
    genetateTextForAboutus(prompt) {
      this.loading_Ai = true;
      let needPack = !this.computedCurrentPackage.count;
      const textMessage = {
        fa: `یک متن فارسی با حداقل 250 کلمه برای بخش "${this.$t(
          "suggestinput.aboutUs",
        )}" تولید کنید که بر مجموعه "${prompt}" برای کارت ویزیت یا بروشور یا معرفی تمرکز داشته باشد. متن باید بسیار توصیفی، حرفه‌ای و جذاب باشد و برای استفاده در تولید محتوای توسط هوش مصنوعی بهینه شود. متن باید حس هویت برند، خلاقیت و حرفه‌ای‌گری را منتقل کند و شامل جزئیات باشد. متن باید برای نمایش در قالب‌های بصری مانند نام مجموعه مناسب باشد و داستان برند را به شکلی خلاقانه و تأثیرگذار روایت کند. از تکرار مستقیم "${prompt}" بیش از حد پرهیز کنید و آن‌ها را به‌صورت طبیعی در متن ادغام کنید. فقط متن فارسی تولید شود، بدون توضیحات اضافی یا جملات غیرمرتبط.`,
        en: `Generate an English text with at least 250 words for the "${this.$t(
          "suggestinput.aboutUs",
        )}" section, focusing on the "${prompt}" collection for a business card, brochure, or introduction. The text must be highly descriptive, professional, and engaging, optimized for AI-generated content. It should convey a sense of brand identity, creativity, and professionalism, with rich details. The text should be suitable for visual formats, such as the collection name, and narrate the brand story in a creative and impactful way. Avoid excessive repetition of "${prompt}" and integrate it naturally into the text. Generate only English text, without additional explanations or irrelevant sentences.`,
        ar: `أنشئ نصًا باللغة العربية يتكون من 250 كلمة على الأقل لقسم "${this.$t(
          "suggestinput.aboutUs",
        )}"، مع التركيز على مجموعة "${prompt}" لبطاقة عمل أو بروشور أو مقدمة. يجب أن يكون النص وصفيًا للغاية، احترافيًا وجذابًا، ومُحسّنًا للمحتوى المُولد بواسطة الذكاء الاصطناعي. يجب أن ينقل النص هوية العلامة التجارية، الإبداع والاحترافية، مع تفاصيل غنية. يجب أن يكون النص مناسبًا للتنسيقات البصرية، مثل اسم المجموعة، وأن يروي قصة العلامة التجارية بطريقة إبداعية ومؤثرة. تجنب التكرار المفرط لـ "${prompt}" ودمجه بشكل طبيعي في النص. أنشئ نصًا باللغة العربية فقط، دون شروحات إضافية أو جمل غير ذات صلة.`,
      }[this.$i18n.locale];
      this.$api
        .post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: textMessage,
        })
        .then(({ data }) => {
          this.computedValue = data.choices[0].message.content;
          this.currentPackage = data.package;

          if (needPack && !data.package.remaining) {
            this.showUpgrade = true;
            this.$modal.error(
              this.$t("suggestinput.error"),
              rest.message || this.$t("suggestinput.errorMessage"),
            );
          }
        })
        .catch((err) => {
          let message = this.$t("suggestinput.errorMessage_400");
          if (err.response.status === 403) {
            this.$toast.error(this.$t("suggestinput.errorMessage_403"));
            this.showUpgrade = err.response.status === 403;
          } else {
            this.$modal.error(this.$t("suggestinput.error"), message);
          }
          this.loading_Ai = false;
        })
        .finally(() => {
          this.loading_Ai = false;
        });
    },
  },
  computed: {
    cons() {
      return {
        title: this.$t("suggestinput.title"),
      };
    },
    computedCurrentPackage() {
      let packages = this.currentPackage;

      return packages.remaining instanceof Array
        ? packages.remaining.reduce((obj, curr) => {
            obj.free = false;

            if (!obj.hasOwnProperty("count"))
              obj.count = Number(curr.remaining);
            else obj.count += Number(curr.remaining);

            return obj;
          }, {})
        : {
            free: packages.package_id === null,
            count: packages.remaining,
          };
    },
    header() {
      let token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getPackage() {
      axios
        .get(this.$aiApi + "/packages/user/package", {
          headers: this.header(),
        })
        .then((data) => {
          this.currentPackage = data.data.data;
          if (!this.currentPackage.remaining) {
            this.showUpgrade = true;
          }
        })

        .catch((response) => {
          console.error(response);
        })
        .finally(() => {});
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.getPackage();
    // const temp = this.value;
    // this.$emit('input', 'salam');
    // this.$nextTick(() => {
    //   this.$emit('input', temp);
    // });
  },
};
</script>

<style scoped>
.v-input >>> .v-input__append-inner {
  margin: 0;
}
</style>
